import React, { useState } from "react";
import styled from "styled-components";

// 범용 물음표 툴팁 — hover 시 설명 말풍선 표시 //
// props:
//  - text       : 말풍선에 표시할 설명 (필수, \n 줄바꿈 지원)
//  - size       : 물음표 아이콘 지름 (기본 20)
//  - direction  : 말풍선 위치 'left' | 'right' (기본 'left' = 아이콘 왼쪽)
//  - maxWidth   : 말풍선 최대 너비 (기본 240, 초과 시 줄바꿈)
export default function MoreExplanationView(props) {
  const { text, size = 20, direction = 'left', maxWidth = 240 } = props;

  const [isHover, setIsHover] = useState(false);

  return (
    <TopLevelWrapper>
      <BubbleWrapper $isHover={isHover} $direction={direction}>
        {
          direction === 'right' &&
          <Triangle $direction='right' />
        }
        <BubbleBox $maxWidth={maxWidth}>
          <BubbleText>{text}</BubbleText>
        </BubbleBox>
        {
          direction === 'left' &&
          <Triangle $direction='left' />
        }
      </BubbleWrapper>
      <QuestionMarkBox
        $size={size}
        $isHover={isHover}
        onMouseOver={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}>
        <QuestionMarkText>?</QuestionMarkText>
      </QuestionMarkBox>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  position: relative;

  display: inline-flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
`;

const BubbleWrapper = styled.div`
  position: absolute;
  z-index: 10;

  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  top: 50%;
  ${props => props.$direction === 'left' ? `right: calc(100% + 4px);` : `left: calc(100% + 4px);`}
  transform: translateY(-50%);

  opacity: ${props => props.$isHover ? 1 : 0};
  pointer-events: none;

  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.15));

  transition: opacity 0.3s ease-in-out;
`;

const BubbleBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: max-content;
  max-width: ${props => props.$maxWidth}px;

  padding: 10px;

  border-radius: 5px;
  background-color: ${props => props.theme.primary};
`;

const BubbleText = styled.p`
  margin: 0 0 0 0;

  font-family: NotoSansKR-Medium;
  font-size: 14px;
  line-height: 20px;
  color: ${props => props.theme.white};

  word-break: keep-all;
  white-space: pre-line;
`;

const Triangle = styled.div`
  width: 0;
  height: 0;

  flex-shrink: 0;

  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: ${props => props.$direction === 'left' ? `6px solid ${props.theme.primary}` : `0`};
  border-right: ${props => props.$direction === 'right' ? `6px solid ${props.theme.primary}` : `0`};
`;

const QuestionMarkBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;

  border: 1px solid ${props => props.$isHover ? props.theme.primary : props.theme.primaryAlpha50};
  border-radius: ${props => props.$size}px;
  background-color: ${props => props.$isHover ? props.theme.primary : props.theme.primaryAlpha50};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const QuestionMarkText = styled.p`
  margin: 0 0 0 0;

  font-family: NotoSansKR-Bold;
  font-size: 10px;
  color: ${props => props.theme.white};
`;
